import { lazy } from "react";
import MapSlot from "../shared/MapSlot";
import type { MadMonkeyMapProps } from "./MadMonkeyMap";

// MapLibre is big and browser-only, so it is its own chunk and never part of the page's first paint.
const MadMonkeyMap = lazy(() => import("./MadMonkeyMap"));

/** The Mad Monkey map in its slot: see MapSlot for when it mounts. */
const LiveMap = ({ still, ...props }: MadMonkeyMapProps & { still?: boolean }) => (
	<MapSlot still={still}>
		<MadMonkeyMap {...props} />
	</MapSlot>
);

export default LiveMap;
